import iconCheck from '@/assets/imgs/icon-check.svg'

import * as S from './styles'

export type Props = {
  icon?: string
  color?: string
  size?: number
  ariaLabel?: string
}

const Icon = ({
  icon = iconCheck,
  color = '#D8D8D8',
  size = 16,
  ariaLabel = 'Icon image',
  ...props
}: Props) => (
  <S.Icon
    icon={icon}
    size={size}
    color={color}
    aria-label={ariaLabel}
    {...props}
  />
)

export default Icon
